import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import Therapy from './screens/index.vue';
const SplittedBagConfig = () => import('./screens/index.vue')

const splittedBagConfigRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.SPLITTED_BAG_CONFIG
  ])
) {
  splittedBagConfigRoutes.push({
    path: '/bolsa-multi/configuracoes',
    name: 'Cadastro / Consulta|Bolsa Compart - Configurações',
    component: SplittedBagConfig,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { splittedBagConfigRoutes };

